<ng-container *ngIf="!!params">
    <tt-input ttLabel="prod_id" [(ttModel)]="params.prod_id" ttReadonly></tt-input>
    <tt-input ttLabel="prod_name" [(ttModel)]="params.prod_name" (ttModelChange)="onChanged('prod_name')">
        <tt-form-field-button buttons ttIcon="fas fa-chevron-right" ttGoto="productlangs" [ttGotoParms]="{ prod_id: params.prod_keyno }"></tt-form-field-button>
    </tt-input>
    <tt-input ttLabel="short_name" [(ttModel)]="params.prod_name_short" (ttModelChange)="onChanged('prod_name_short')"></tt-input>
    <tt-input ttLabel="prod_search_name" [(ttModel)]="params.prod_search_name" (ttModelChange)="onChanged('prod_search_name')"></tt-input>
    <!-- fileserver is not up so i havent gotten to test if this works. -->
    <tt-ie-http-img *ngIf="params.setting_use_external_product_images === '0'" [imageUrl]="productImageUrl" />
    <tt-image *ngIf="params.setting_use_external_product_images === '1'" ttLabel="picture" [ttSrc]="params.url_picture" (ttPlaceholderClick)="onImagePlaceholderClick($event)"></tt-image>
    <tt-select
        *ngIf="params.edit_unit_stock_possible === '1'"
        ttLabel="prod_stock_unit_no"
        [(ttModel)]="params.prod_stock_unit_no"
        (ttModelChange)="onChanged('prod_stock_unit_no')"
        [ttData]="units"
        ttDataId="unit_no"
        ttDataName="unit_name"
    >
        <tt-form-field-button buttons ttIcon="fas fa-chevron-right" ttGoto="productmultiunit" [ttGotoParms]="{ prod_id: params.prod_keyno }"></tt-form-field-button>
    </tt-select>
    <tt-input *ngIf="params.edit_unit_stock_possible === '0'" ttLabel="prod_stock_unit_no" [(ttModel)]="params.prod_stock_unit_name" ttReadonly>
        <tt-form-field-button buttons ttIcon="fas fa-chevron-right" ttGoto="productmultiunit" [ttGotoParms]="{ prod_id: params.prod_keyno }"></tt-form-field-button>
    </tt-input>
    <tt-select ttLabel="businessco" [(ttModel)]="params.businessco_no" (ttModelChange)="onChanged('businessco_no')" [ttData]="companies" ttDataId="businessco_no" ttDataName="company_name"></tt-select>
    <tt-toast *ngIf="params.warning_productunit > ''" class="col-xs-12 sp-0" [ttTitle]="params.warning_productunit" ttTranslateTitle="false" ttType="danger"></tt-toast>
    <tt-select ttLabel="prodtype_no" [(ttModel)]="params.prodtype_no" (ttModelChange)="onChanged('prodtype_no')" [ttData]="productTypes" ttDataId="prodtype_no" ttDataName="prodtype_name"></tt-select>
    <ng-container *ngIf="params.prodtype_no === '7'">
        <tt-checkbox ttLabel="restrictpossibility" [(ttModel)]="params.restrictpossibility" (ttModelChange)="onChanged('restrictpossibility')"></tt-checkbox>
        <tt-checkbox ttLabel="pricemethod_sum" [(ttModel)]="params.pricemethod_sum" (ttModelChange)="onChanged('pricemethod_sum')"></tt-checkbox>
        <tt-select
            ttLabel="pricegrpmethod"
            [(ttModel)]="params.pricegrpmethod_id"
            (ttModelChange)="onChanged('pricegrpmethod_id')"
            [ttData]="priceGroupMethods"
            ttDataId="pricegrpmethod_id"
            ttDataName="pricegrpmethod_name"
            [ttReadonly]="params.enable_change_pricegrpmethod_id === '0'"
        ></tt-select>
        <tt-input ttLabel="pricegrps_info" [(ttModel)]="params.pricegrps_info" ttReadonly>
            <tt-form-field-button buttons ttIcon="fas fa-chevron-right" ttGoto="choiceprodpricegrps" [ttGotoParms]="{ prod_id: params.prod_keyno }"></tt-form-field-button>
        </tt-input>
    </ng-container>
    <tt-select
        *ngIf="params.show_colorgrp_id === '1'"
        ttLabel="product_colorgrp_id"
        [(ttModel)]="params.colorgrp_id"
        (ttModelChange)="onChanged('colorgrp_id')"
        [ttData]="colorGroups"
        ttDataId="item_id"
        ttDataName="item_name"
    ></tt-select>
    <tt-select
        ttRequired
        ttLabel="prodgrp"
        [(ttModel)]="params.prodgrp_id"
        (ttModelChange)="onProductGroupChanged()"
        [ttData]="productGroups"
        ttDataId="item_id"
        ttDataName="item_name"
        [ttReadonly]="params.setting_can_edit_prodgrp === '0'"
    >
        <ng-container buttons>
            <tt-form-field-button ttIcon="fas fa-bars" ttGoto="prodgrps"></tt-form-field-button>
            <tt-form-field-button *ngIf="params.prodgrp_id > ''" ttIcon="fas fa-chevron-right" ttGoto="prodgrpmenu" [ttGotoParms]="{ prodgrp_id: params.prodgrp_id }"></tt-form-field-button>
        </ng-container>
    </tt-select>
    <tt-select
        [hidden]="productGroup2s.length === 0"
        ttLabel="prodgrp2"
        [(ttModel)]="params.prodgrp2_id"
        (ttModelChange)="onProductGroup2Changed()"
        [ttData]="productGroup2s"
        ttDataId="item_id"
        ttDataName="item_name"
        [ttShowClearButton]="params.prodgrp2_id > ''"
        [ttClearValue]="''"
        [ttReadonly]="params.setting_can_edit_prodgrp === '0'"
    ></tt-select>
    <tt-select
        [hidden]="productGroup3s.length === 0"
        ttLabel="prodgrp3"
        [(ttModel)]="params.prodgrp3_id"
        (ttModelChange)="onProductGroup3Changed()"
        [ttData]="productGroup3s"
        ttDataId="item_id"
        ttDataName="item_name"
        [ttShowClearButton]="params.prodgrp3_id > ''"
        [ttClearValue]="''"
        [ttReadonly]="params.setting_can_edit_prodgrp === '0'"
    ></tt-select>
    <tt-select
        [hidden]="productGroup4s.length === 0"
        ttLabel="prodgrp4"
        [(ttModel)]="params.prodgrp4_id"
        (ttModelChange)="onChanged('prodgrp4_id')"
        [ttData]="productGroup4s"
        ttDataId="item_id"
        ttDataName="item_name"
        [ttShowClearButton]="params.prodgrp4_id > ''"
        [ttClearValue]="''"
        [ttReadonly]="params.setting_can_edit_prodgrp === '0'"
    ></tt-select>
    <tt-select
        ttLabel="model_name"
        [(ttModel)]="params.model_id"
        (ttModelChange)="onChanged('model_id')"
        [ttData]="models"
        ttDataId="item_id"
        ttDataName="item_name"
        [ttClearValue]="''"
        ttShowClearButton
    >
        <ng-container buttons>
            <tt-form-field-button buttons ttIcon="fas fa-bars" ttGoto="models"></tt-form-field-button>
        </ng-container>
    </tt-select>
    <tt-select
        ttLabel="collection"
        [(ttModel)]="params.collection_keyno"
        (ttModelChange)="onChanged('collection_keyno')"
        [ttData]="collections"
        ttDataId="item_id"
        ttDataName="item_name"
        [ttClearValue]="''"
        ttShowClearButton
    >
        <ng-container buttons>
            <tt-form-field-button buttons ttIcon="fas fa-bars" ttGoto="collections"></tt-form-field-button>
        </ng-container>
    </tt-select>
    <tt-select
        ttLabel="assortment"
        [(ttModel)]="params.assortment_keyno"
        (ttModelChange)="onChanged('assortment_keyno')"
        [ttData]="assortments"
        ttDataId="assortment_keyno"
        ttDataName="assortment_name"
        ttShowClearButton
    ></tt-select>
    <tt-select
        *ngIf="params.show_servicetype === '1'"
        ttLabel="servicetype"
        [(ttModel)]="params.servicetype_no"
        (ttModelChange)="onChanged('servicetype_no')"
        [ttData]="serviceTypes"
        ttDataId="servicetype_no"
        ttDataName="servicetype_name"
        [ttClearValue]="''"
        ttShowClearButton
    >
        <tt-form-field-button buttons ttIcon="fas fa-bars" ttGoto="collections"></tt-form-field-button>
    </tt-select>
    <tt-select
        ttLabel="prodcycle"
        [(ttModel)]="params.prodcycle_no"
        (ttModelChange)="onChanged('prodcycle_no')"
        [ttData]="productCycles"
        ttDataId="prodcycle_no"
        ttDataName="prodcycle_name"
    ></tt-select>
    <tt-checkbox *ngIf="params.show_custom_check_01 === '1'" ttLabel="custom_check_01" [(ttModel)]="params.custom_check_01" (ttModelChange)="onChanged('custom_check_01')"></tt-checkbox>
    <tt-textarea *ngIf="params.show_prod_designinfo === '1'" ttLabel="prod_designinfo" [(ttModel)]="params.prod_designinfo" (ttModelChange)="onChanged('prod_designinfo')"></tt-textarea>
    <tt-textarea *ngIf="params.show_note === '1'" ttLabel="note" [(ttModel)]="params.note" (ttModelChange)="onChanged('note')"></tt-textarea>
    <tt-checkbox ttLabel="is_dangerousgoods" [(ttModel)]="params.is_dangerousgoods" (ttModelChange)="onChanged('is_dangerousgoods')"></tt-checkbox>
    <ng-container *ngIf="params.is_dangerousgoods === '1'">
        <tt-input ttLabel="dangerousgoods_un_number" [(ttModel)]="params.dangerousgoods_un_number" (ttModelChange)="onChanged('dangerousgoods_un_number')"></tt-input>
        <tt-input ttLabel="dangerousgoods_hazardclass" [(ttModel)]="params.dangerousgoods_hazardclass_id" ttReadonly>
            <tt-form-field-button buttons ttIcon="fas fa-chevron-right" ttGoto="producthazardlabels" [ttGotoParms]="{ prod_id: params.prod_keyno.substring(12) }"></tt-form-field-button>
        </tt-input>
        <tt-input ttLabel="dangerousgoods_tunnelcode" [(ttModel)]="params.dangerousgoods_tunnelcode_id" (ttModelChange)="onChanged('dangerousgoods_tunnelcode_id')"></tt-input>
    </ng-container>
    <tt-input *ngIf="params.show_env_tax_pst === '1'" ttLabel="environmental_tax_pst" [(ttModel)]="params.environmental_tax_pst" (ttModelChange)="onChanged('environmental_tax_pst')"></tt-input>
</ng-container>
